import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { MDText } from 'i18n-react';

const PcoLinkedEntitiesCellItem = ({ entity }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  return (
    <span>
      {T.translate('PCO')}-{entity.number}
    </span>
  );
};

PcoLinkedEntitiesCellItem.propTypes = {
  /**
   * The PCO entity we need to render.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    number: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
  }).isRequired
};

export default PcoLinkedEntitiesCellItem;
